import { render, staticRenderFns } from "./gddetail.vue?vue&type=template&id=793ca6f4&scoped=true&"
import script from "./gddetail.vue?vue&type=script&lang=js&"
export * from "./gddetail.vue?vue&type=script&lang=js&"
import style0 from "./gddetail.vue?vue&type=style&index=0&id=793ca6f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ca6f4",
  null
  
)

export default component.exports